import { withFooterAchievements, FooterAchievementsOutputProps } from "./withFooterAchievements"
import React from "react"
import tw from "twin.macro"

const Container = tw.aside`
  flex flex-wrap grid-flow-col grid-cols-2 w-full m-0 -ml-mini pb-mini
`

const Image = tw.img`
  p-mini
`

const IconWrapper = tw.span`
  flex h-auto w-auto
`

export const FooterAchievements = withFooterAchievements(({ icons }: FooterAchievementsOutputProps) => (
  <Container>
    {icons?.map((icon, i) => (
      <IconWrapper key={i}>
        <Image src={icon?.asset?.url} alt={icon?.alt} />
      </IconWrapper>
    ))}
  </Container>
))
